define(function(require,exports,module){
	var config = require( '../enums/config' );

	return function(name){
		return config.className + (name ? "-" + name : '');
	}
});